<template>
  <div style="position: relative">
    <div class="head_op flex">
      <el-button size="mini" @click="addLecture" class="addBtn">新增讲座</el-button>
      <el-input class="addART"
                placeholder="讲座名称"
                v-model="page.name"
                @change="skipPage(1)"
                suffix-icon="el-icon-search">
      </el-input>
    </div>
    <el-tabs v-model="activeName" class="tabs" @tab-click="changeTab">
      <el-tab-pane name="online" label="在线讲座" class="mineCon">
        <div class="typeHead">
          <div class="medicineType flex">
            <span class="typeTit">筛选：</span>
            <div class="medicineTypeL">
              <span><label :class="active.status==0?'activeClass':''" @click="changeStatus(0,-1)">不限</label></span>
              <span><label :class="active.status==1?'activeClass':''" @click="changeStatus(1,1)">发布中</label></span>
              <span><label :class="active.status==2?'activeClass':''" @click="changeStatus(2,0)">未发布</label></span>
            </div>
          </div>
          <div class="medicineType flex">
            <span class="typeTit">专业分类：</span>
            <div class="medicineTypeL">
                        		<span>
									<label :class="active.speciality==0?'activeClass':''"
                         @click="change(0,1,0)">不限</label>
								</span>
              <span v-for="(item,index) in specialities" :key="index">
									<label :class="active.speciality==index+1?'activeClass':''"
                         @click="change(index+1,1,item.id,)">{{ item.itemName }}</label>
								</span>
            </div>
          </div>
          <div class="medicineType flex">
            <span class="typeTit">讲座分类：</span>
            <div class="medicineTypeL">
                                <span>
									<label :class="active.level==0?'activeClass':''" @click="change(0,2,0)">不限</label>
								</span>
              <span v-for="(item,index) in levels" :key="index">
                            		<label :class="active.level==index+1?'activeClass':''"
                                       @click="change(index+1,2,item.id)">{{ item.itemName }}</label>
                        		</span>
            </div>
          </div>
        </div>
        <div class="instrument ">
          <el-table :data="page.rows" class="record-table"
                    :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                    height="calc(100vh - 455px)"
                    max-height="calc(100vh - 455px)">
            <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="subTitle" label="副标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" width="100" align="center">
                            <span slot-scope="scope" class="common" :class="scope.row.status == 0?'yellow':'green'"
                                  @click="updateStatus(scope.row)">
                                {{ scope.row.status | statusFmt }}
                            </span>
            </el-table-column>
            <el-table-column prop="meetStartDate" label="开始时间" width="150" align="center">
              <template slot-scope="scope">{{ scope.row.startDate | dateFmt }}</template>
            </el-table-column>
            <el-table-column prop="meetEndDate" label="结束时间" width="150" align="center">
              <template slot-scope="scope">{{ scope.row.endDate | dateFmt }}</template>
            </el-table-column>
            <el-table-column prop="deadlineDate" label="截止时间" width="170" align="center">
              <template slot-scope="scope">{{ scope.row.deadlineDate | dateFmt }}</template>
            </el-table-column>
            <el-table-column prop="registerCount" label="报名人数" width="100" align="center">
              <template slot-scope="scope">
                <el-button @click="showRegister(scope.row)" class="btn" type="text">
                  {{ scope.row.registerCount }}
                </el-button>
              </template>
            </el-table-column>

            <el-table-column prop="id" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button @click="toDetail(scope.row.id,1)" class="btn" type="text" size="small">
                  详情
                </el-button>
                <el-button @click="toEdit(scope.row.id)" class="btn" type="text" size="small">编辑
                </el-button>
                <el-button @click="del(scope.row.id)" class="btn" type="text" size="small">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px"
                         class="pagination"
                         background
                         prev-text="Prev"
                         next-text="Next"
                         @current-change="skipPage"
                         :current-page="page.current"
                         :page-size="page.size"
                         layout="prev, pager, next"
                         :total="page.total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane name="video" label="视频讲座" class="mineCon ">
        <div class="typeHead">
          <div class="medicineType flex">
            <span class="typeTit">筛选：</span>
            <div class="medicineTypeL">
                                <span><label :class="active.status==0?'activeClass':''"
                                             @click="changeStatus(0,-1)">不限</label></span>
              <span><label :class="active.status==1?'activeClass':''"
                           @click="changeStatus(1,1)">发布中</label></span>
              <span><label :class="active.status==2?'activeClass':''"
                           @click="changeStatus(2,0)">未发布</label></span>
            </div>
          </div>
          <div class="medicineType flex">
            <span class="typeTit">专业分类：</span>
            <div class="medicineTypeL">
								<span>
									<label :class="active.speciality==0?'activeClass':''"
                         @click="change(0,1,0)">不限</label>
								</span>
              <span v-for="(item,index) in specialities" :key="index">
									<label :class="active.speciality==index+1?'activeClass':''"
                         @click="change(index+1,1,item.id,)">{{ item.itemName }}</label>
								</span>
            </div>
          </div>
          <div class="medicineType flex">
            <span class="typeTit">讲座分类：</span>
            <div class="medicineTypeL">
                                <span>
									<label :class="active.level==0?'activeClass':''" @click="change(0,2,0)">不限</label>
								</span>
              <span v-for="(item,index) in levels" :key="index">
                            		<label :class="active.level==index+1?'activeClass':''"
                                       @click="change(index+1,2,item.id)">{{ item.itemName }}</label>
                        		</span>
            </div>
          </div>
        </div>
        <div class="instrument">
          <el-table :data="page.rows" class="record-table"
                    :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                    height="calc(100vh - 435px)"
                    max-height="calc(100vh - 435px)">
            <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="subTitle" label="副标题" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" width="100" align="center">
                            <span slot-scope="scope" class="common" :class="scope.row.status == 0?'yellow':'green'"
                                  @click="updateStatus(scope.row)">
                                {{ scope.row.status | statusFmt }}
                            </span>
            </el-table-column>
            <el-table-column prop="registerCount" label="观看人数" width="100" align="center">
              <template slot-scope="scope">
                <el-button @click="showRegister(scope.row)" class="btn" type="text">
                  {{ scope.row.registerCount }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button @click="toDetail(scope.row.id,2)" class="btn" type="text" size="small">
                  详情
                </el-button>
                <el-button @click="toEdit(scope.row.id)" class="btn" type="text" size="small">编辑
                </el-button>
                <el-button @click="del(scope.row.id)" class="btn" type="text" size="small">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              class="pagination"
              background
              prev-text="Prev"
              next-text="Next"
              @current-change="skipPage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next"
              :total="page.total">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 报名人员 dialog table -->
    <el-drawer title="已报名人员列表" :visible.sync="userListDialog" :show-close="false" size="1000px" class="drawerCommon"
               :close-on-press-escape="false">
      <el-table :data="userPage.rows" class="record-table"
                height="calc(100vh - 130px)"
                max-height="calc(100vh - 130px)"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}">
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userType" label="类型" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.userType == 1 ? '用户' : scope.row.userType == 2 ? '医生' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.gender == 1 ? '男' : scope.row.gender == 0 ? '女' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="80" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机" width="140" align="center"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
        <el-table-column prop="abodeCity" label="所在城市" align="center"></el-table-column>
        <el-table-column prop="occupation" label="职业"></el-table-column>
        <el-table-column prop="registerDate" label="报名时间" width="140" align="center">
          <template slot-scope="scope">{{ scope.row.registerDate | dateFmt }}</template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 8px;">
        <el-pagination
            class="pagination"
            :hide-on-single-page="true"
            background
            prev-text="Prev"
            next-text="Next"
            @current-change="skipUserPage"
            :current-page="userPage.current"
            :page-size="userPage.size"
            layout="total, prev, pager, next"
            @close="userPage.mid=''"
            :total="userPage.total">
        </el-pagination>
      </div>
    </el-drawer>


    <!-- edit dialog -->
    <el-drawer :title="editDialogTitle"
               :visible.sync="editDialog"
               :wrapperClosable="false"
               :show-close="false" size="800px" class="drawerCommon" :close-on-press-escape="false"
               @open="handleOpen"
               @close="clearForm">
      <el-form :model="editForm" label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="标题">
          <el-input v-model="editForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="editForm.subTitle" placeholder="请输入副标题"></el-input>
        </el-form-item>
        <el-form-item label="缩略图">
          <el-upload name="uploadFile"
                     :action="uploadUrl"
                     :accept="'image/*'"
                     :show-file-list="false"
                     :on-success="handleUploadSuccess"
                     :on-error="handleUploadError"
                     class="avatar-uploader">
            <img v-if="editForm.thumbnailPath" :src="editForm.thumbnailPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="分类">
          <el-select v-model="editForm.specialityId" placeholder="请选择专业分类">
            <el-option v-for="item in specialities" :key="item.id" :label="item.itemName"
                       :value="item.id+''"></el-option>
          </el-select>
          <el-select v-model="editForm.levelId" placeholder="请选择讲座分类" style="margin-left: 20px;">
            <el-option v-for="item in levels" :key="item.id" :label="item.itemName" :value="item.id+''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="讲座类型">
          <el-radio-group v-model="editForm.lectureType">
            <el-radio label="1">普通讲座</el-radio>
            <el-radio label="2">视频讲座</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="讲座时间" v-if="editForm.lectureType==1">
          <el-date-picker
              v-model="editForm.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="截止时间" v-if="editForm.lectureType==1">
          <el-date-picker v-model="editForm.deadlineDate" type="datetime" placeholder="选择报名截止时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="最大报名数" v-if="editForm.lectureType==1">
          <el-input-number v-model="editForm.maxRegisterCount" :min="1" label="最大报名人数"></el-input-number>
        </el-form-item>
        <el-form-item label="视频文件" v-if="editForm.lectureType==2">
          <el-radio-group v-model="uploadModel">
            <el-radio label="1">本地上传</el-radio>
            <el-radio label="2">填写地址</el-radio>
          </el-radio-group>
          <template v-if="uploadModel==1">
            <el-upload v-if="!editForm.videoPath" ref="videoUpload" name="uploadFile"
                       :limit=1
                       :accept="'video/*'"
                       :file-list="videoFileList"
                       :action="uploadUrl"
                       :on-success="handleUploadVideoSuccess"
                       :on-error="handleUploadVideoError"
                       :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="uploadVideo">上传到服务器</el-button>
            </el-upload>
            <div v-else class="video-path">
              <i>视频地址: </i>
              <el-link type="primary" @click="previewVideo">{{ editForm.videoPath }}</el-link>
              <i class="el-icon-delete" @click="removeVideo" title="remove video"
                 style="margin-left: 8px;font-size: 20px; vertical-align: bottom; cursor: pointer; color: #F56C6C"></i>
            </div>
          </template>
          <template v-else>
            <el-input v-model="editForm.videoPath" placeholder="请输入视频地址"></el-input>
          </template>
        </el-form-item>

        <el-form-item label="讲座医生" class="doctor-select">

          <!--<span style="cursor: pointer;vertical-align: sub;" @click="doctorSelectDialog = true">
              <i class="el-icon-circle-plus-outline" style="font-size: 24px; color: #409eff;"></i>
          </span>

          <span class="user_item" v-for="doctor in editForm.doctors" :key="doctor.id">
              <span>{{doctor.fullName}}</span>
              <i class="el-icon-delete" @click="removeDoctor(doctor.id)"></i>
          </span>-->
          <el-select v-model="editForm.doctors" filterable multiple placeholder="请选择医生">
            <el-option
                v-for="item in doctors"
                :key="item.id"
                :label="item.fullName + ' (' + item.account + ')'"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="简介">
          <el-input type="textarea" rows="3" v-model="editForm.briefDesc" placeholder="简介"></el-input>
        </el-form-item>
        <el-form-item label="说明" class="quill_parent" style="height: 460px;">
          <quill-editor style="height: 400px" v-model="editForm.explanation" @ready="quillEditorReadyHandle"
                        :options="editorOption" ref="myQuillEditor"></quill-editor>
        </el-form-item>
      </el-form>
      <div style="display: none">
        <input type="file" id="quill_img_input" @change="uploadQuillImg" accept="image/*"/>
      </div>
      <div class="footer">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="editDialog=false">取消</el-button>
      </div>

      <!-- select doctor -->
      <!--<el-dialog title="选择医生" :visible.sync="doctorSelectDialog" append-to-body width="400px">

          <el-button type="primary">确定</el-button>
      </el-dialog>-->

    </el-drawer>


  </div>
</template>

<script>
import base from '@/api/common';
import {quillEditor} from 'vue-quill-editor';
import 'quill/dist/quill.snow.css'

export default {
  name: "lectureManage",
  data() {
    return {
      activeName: 'online',
      tabName: 'online',
      active: {
        status: 0,
        speciality: 0,
        level: 0
      },
      specialities: [],
      levels: [],
      page: {
        current: 1,
        size: 9,
        total: 20,
        specialityId: 0,
        levelId: 0,
        lectureType: 1,
        status: -1,
        name: '',
        rows: []
      },
      /* 用户注册人部分 */
      userPage: {
        current: 1,
        size: 10,
        total: 5,
        rows: [],

        mid: '',
      },
      userListDialog: false,

      /* 讲座编辑部分 */
      editDialog: false,
      editDialogTitle: '',
      editModel: '',
      uploadModel: '1',
      editForm: {
        id: '',
        title: '',
        subTitle: '',
        // 分类
        lectureType: '1', //讲座类型
        specialityId: '',
        levelId: '',

        deadlineDate: '',
        briefDesc: '',
        thumbnailPath: '',
        explanation: '',
        maxRegisterCount: 100,
        doctors: [],
        dateRange: [],
        videoPath: ''
      },

      editorOption: { //  富文本编辑器配置
        theme: 'snow',
        placeholder: '请输入讲座说明文字',
      },
      uploadUrl: base.uploadUrl + "lecture",
      doctors: [{id: 1, fullName: 'a', account: 123}],
      videoFileList: []
    };
  },
  components: {
    quillEditor
  },
  mounted() {
    // load 专业分类
    this.$ajax.get(base.api.dict.lecture.speciality).then((res) => {
      if (res.data.status === 'success') {
        this.specialities = res.data.list;
      }
    });
    // load 讲座分类
    this.$ajax.get(base.api.dict.lecture.level).then((res) => {
      if (res.data.status === 'success') {
        this.levels = res.data.list;
      }
    });
    this.getData();

    window.vue = this;
  },
  methods: {
    changeTab(tab) {
      // 防止重复请求数据
      if (tab.name === this.tabName) {
        return;
      }
      if (tab.name === 'online') {
        this.page.lectureType = 1;
      } else if (tab.name === 'video') {
        this.page.lectureType = 2;
      }

      this.tabName = tab.name;
      this.page.current = 1;
      this.getData();
    },
    getData() {
      this.$ajax.get(base.manager_api.expert.lecture.page, {
        params: {
          page: this.page.current,
          size: this.page.size,
          specialityId: this.page.specialityId,
          levelId: this.page.levelId,
          lectureType: this.page.lectureType,
          status: this.page.status,
          name: this.page.name
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        } else {
          this.$message.error("数据加载失败！");
          console.error(res.data);
        }
      }).catch((err) => {
        this.$message.error("数据加载失败！");
        console.error(err);
      })
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    change(index, type, id) {
      this.page.current = 1;
      if (type === 1) {
        if (this.active.speciality == index) {
          return;
        }
        this.active.speciality = index;
        this.page.specialityId = id;
      } else if (type === 2) {
        if (this.active.level == index) {
          return;
        }
        this.active.level = index;
        this.page.levelId = id;
      }
      this.getData();
    },
    changeStatus(index, status) {
      if (this.active.status == index) {
        return;
      }
      this.active.status = index;
      this.page.current = 1;
      this.page.status = status;
      this.getData();
    },
    updateStatus(row) {
      let that = this;
      if (row) {
        let targetStatus = (row.status + 1) % 2;
        let msg = "确定要" + (targetStatus === 0 ? "取消" : "") + "发布吗?";
        this.$messageBox.confirm(msg, '提示', {type: 'warning'}).then(_ => {
          this.$ajax.post(base.manager_api.expert.lecture.changeStatus.replace("{id}", row.id) + "?status=" + targetStatus).then(res => {
            if (res.data.status === 'success') {
              that.$message.success(res.data.message);
              row.status = targetStatus;
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败');
          })
        });
      }
    },
    showRegister(item) {
      if (item && item.id) {
        if (item.registerCount == 0) {
          this.$message.warning("还没有人报名!");
          return;
        }
        this.userListDialog = true;
        this.userPage.mid = item.id;
        this.skipUserPage(1);
      }
    },
    skipUserPage(current) {
      if (this.userPage.mid) {
        let that = this;
        this.userPage.current = current;
        this.$ajax.get(base.manager_api.expert.register.page.replace("{id}", this.userPage.mid), {
          params: {
            page: that.userPage.current,
            size: that.userPage.size,
          }
        }).then(res => {
          if (res.data.status === 'success') {
            this.userPage.current = res.data.current;
            this.userPage.size = res.data.size;
            this.userPage.total = res.data.total;
            this.userPage.rows = res.data.rows;
          }
        })
      }
    },

    toDetail(id, type) {
      if (type == 1) {
        window.open("/admin/lectureDetails/" + id, '_blank')
      } else if (type == 2) {
        window.open("/admin/lectureDetails_video/" + id, '_blank')
      }
    },
    del(id) {
      let that = this;
      this.$messageBox.confirm("确认要删除吗?", '删除确认', {type: 'warning'}).then(_ => {
        that.$ajax.post(base.manager_api.expert.lecture.del.replace("{id}", id)).then(res => {
          if (res.data.status === 'success') {
            that.$message.success("删除成功");
            that.removeItemById(id);
          } else {
            that.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error("操作失败");
        })
      })
    },
    removeItemById(id) {
      if (id) {
        let index = -1;
        $(this.page.rows).each((i, o) => {
          if (id == o.id) {
            index = i;
            return false;
          }
        });
        if (index >= 0) {
          this.page.rows.splice(index, 1);
        }
      }
    },
    addLecture() {
      this.editDialogTitle = '新增讲座';
      this.editDialog = true;
      this.editModel = 'add';
    },
    toEdit(id) {
      this.editDialogTitle = '编辑讲座';
      this.editDialog = true;
      this.editModel = 'edit';
      this.$ajax.get(base.manager_api.expert.lecture.details.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          if (res.data.data) {
            this.editForm.id = id;
            this.editForm.title = res.data.data.title;
            this.editForm.subTitle = res.data.data.subTitle;
            this.editForm.deadlineDate = new Date(res.data.data.deadlineDate);
            this.editForm.briefDesc = res.data.data.briefDesc;
            this.editForm.thumbnailPath = res.data.data.thumbnailPath;
            this.editForm.explanation = res.data.data.explanation;
            this.editForm.dateRange = [new Date(res.data.data.startDate), new Date(res.data.data.endDate)];
            if (res.data.data.doctors && res.data.data.doctors.length !== 0) {
              this.editForm.doctors = res.data.data.doctors.map((o, i, arr) => {
                return o.id
              });
            } else {
              this.editForm.doctors.length = 0;
            }
            this.editForm.maxRegisterCount = res.data.data.maxRegisterCount;
            this.editForm.videoPath = res.data.data.videoPath;

            // 讲座类型等
            this.editForm.lectureType = res.data.data.lectureType + '';
            this.editForm.specialityId = res.data.data.specialityId + '';
            this.editForm.levelId = res.data.data.levelId + '';
          }
        }
      }).catch((err) => {
        this.$message.error("数据加载失败");
      })
    },
    clearForm() {
      this.editForm.title = '';
      this.editForm.subTitle = '';
      this.editForm.deadlineDate = '';
      this.editForm.briefDesc = '';
      this.editForm.thumbnailPath = '';
      this.editForm.explanation = '';
      this.editForm.dateRange = [];
      this.editForm.doctors.length = 0;
      this.editForm.lectureType = '1';
      this.editForm.specialityId = '';
      this.editForm.levelId = '';
      this.editForm.videoPath = '';

    },
    handleOpen() {
      this.$ajax.get(base.api.doctor.baseAll).then(res => {
        if (res.data.status === 'success') {
          this.doctors = res.data.list;
        }
      });
    },
    quillEditorReadyHandle() {
      // 更改初始的 上传图片行为
      this.$refs['myQuillEditor'].quill.getModule('toolbar').addHandler('image', function () {
        $("#quill_img_input").click();
      })
    },
    uploadQuillImg() {
      let imageFile = $("#quill_img_input")[0].files[0];
      if (!(imageFile && imageFile.type)) {
        return;
      }
      if (imageFile.type.toString().indexOf("image") === -1) {
        this.$message.error("请选择图片文件");
        return;
      }
      let formData = new FormData();
      formData.append("uploadFile", imageFile);

      this.$ajax.post(this.uploadUrl, formData).then(res => {
        if (res.data.status === 'success') {
          // insert quill
          let quillEditor = this.$refs['myQuillEditor'].quill;
          quillEditor.insertEmbed(quillEditor.selection.savedRange.index, 'image', res.data.message);
        } else {
          this.$message.error("图片上传失败!");
        }
      });
    },
    handleUploadSuccess(res, file, fileList) {
      if (res.status === 'success') {
        this.editForm.thumbnailPath = res.message;
      } else {
        this.$message.error("图片上传失败");
        this.editForm.thumbnailPath = "";
      }
    },
    handleUploadError(event, file, fileList) {
      this.$message.error("图片上传失败");
      this.editForm.thumbnailPath = "";
    },
    uploadVideo() {
      if (this.$refs.videoUpload.uploadFiles.length === 0) {
        this.$message.warning("未选择文件");
        return;
      }
      // 上传视频
      this.$refs.videoUpload.submit();
    },
    handleUploadVideoSuccess(res, file, fileList) {
      if (res.status === 'success') {
        this.editForm.videoPath = res.message;
        this.$message.success("上传成功");
      } else {
        this.$message.error("视频上传失败");
        this.editForm.videoPath = "";
      }
    },
    handleUploadVideoError(event, file, fileList) {
      this.$message.error("视频上传失败");
      this.editForm.videoPath = "";
    },
    previewVideo() {
      window.open(this.editForm.videoPath, '_blank');
    },
    removeVideo() {
      this.$messageBox.confirm('确定要移除这个视频吗?', '删除确认', {type: 'warning'}).then(_ => {
        this.editForm.videoPath = '';
      }).catch(_ => {
      });
    },
    save() {
      if ($.trim(this.editForm.title).length === 0) {
        this.$message.warning("标题不能为空");
        return;
      }
      if ($.trim(this.editForm.thumbnailPath).length === 0) {
        this.$message.warning("缩略图不能为空");
        return;
      }
      if (!this.editForm.specialityId || !this.editForm.levelId) {
        this.$message.warning("请正确选择分类");
        return;
      }
      if (this.editForm.lectureType) {
        if (this.editForm.lectureType == 1) { //普通
          if (this.editForm.dateRange.length !== 2) {
            this.$message.warning("讲座时间选择错误");
            return;
          }
          if (!this.editForm.deadlineDate) {
            this.$message.warning("讲座截止时间不能为空");
            return;
          }
          // 时间判断
          if (this.editForm.dateRange[0].getTime() < this.editForm.deadlineDate.getTime()) {
            this.$message.warning("截止时间应在开始时间之前");
            return;
          }
        } else if (this.editForm.lectureType == 2) {
          if ($.trim(this.editForm.videoPath).length === 0) {
            this.$message.warning("视频讲座必须上传视频");
            return;
          }
        } else {
          this.$message.error("类型错误");
          return;
        }
      } else {
        this.$message.warning("请选择讲座类型");
        return;
      }

      let reqData = {
        title: this.editForm.title,
        subTitle: this.editForm.subTitle,
        lectureType: this.editForm.lectureType,
        specialityId: this.editForm.specialityId,
        levelId: this.editForm.levelId,
        thumbnailPath: this.editForm.thumbnailPath,
        briefDesc: this.editForm.briefDesc,
        explanation: this.editForm.explanation,
        doctors: this.editForm.doctors.map((o, i, arr) => {
          return {id: o}
        })
      };

      if (this.editForm.lectureType == 1) { // 普通
        reqData.startDate = this.editForm.dateRange[0].Format("yyyy/MM/dd HH:mm:ss");
        reqData.endDate = this.editForm.dateRange[1].Format("yyyy/MM/dd HH:mm:ss");
        reqData.deadlineDate = this.editForm.deadlineDate.Format("yyyy/MM/dd HH:mm:ss");
        reqData.maxRegisterCount = this.editForm.maxRegisterCount;
      } else {
        reqData.videoPath = this.editForm.videoPath;
      }
      let url = '';
      if (this.editModel === 'add') {
        url = base.manager_api.expert.lecture.add;
      } else if (this.editModel === 'edit') {
        url = base.manager_api.expert.lecture.update.replace("{id}", this.editForm.id);
      }
      this.$ajax.post(url, reqData).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('保存成功');
          this.editDialog = false;
          this.skipPage(1);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('操作失败');
        console.error(err);
      });
    },
  },
  filters: {
    statusFmt(status) {
      if (status || status == 0) {
        if (status == 0) {
          return "未发布";
        } else if (status == 1) {
          return "已发布";
        }
      }
      return "-";
    },
    dateFmt(date, pattern) {
      if (date) {
        if (!pattern) {
          pattern = "yyyy-MM-dd HH:mm";
        }
        return new Date(date).Format(pattern);
      }
      return "-";
    },
  }
}
</script>


<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

div[data-state] {
  cursor: pointer
}

span.common{
  cursor: pointer;
}

div[data-state='1'] {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

div[data-state='0'] {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}

::v-deep div.el-dialog {
  .el-dialog__body {
    max-height: calc(100vh - 280px) !important;
    min-height: 100px;
    overflow-y: scroll;
  }
}

::v-deep .el-dialog__wrapper {
  overflow: unset
}


.doctor-select .el-select {
  width: 50%
}

.el-select__tags {
  max-width: unset !important;
}

.video-path {
  height: 20px;
  line-height: 20px;
  //margin-left: 12px;
}

.addART {
  margin-left: 20px
}
</style>